/*
 * Regras de tela do formulário de credenciais montado pelo
 * DynamicCredentialsDataParser ({ [key]: { type, value, required, readOnly... } }).
 */

interface CredentialsField {
    type: string;
    value: any;
    required?: boolean;
    readOnly?: boolean;
    [key: string]: any;
}

interface CredentialsForm {
    [key: string]: CredentialsField;
}

const SECRET_KEY = /secret|password|senha|token|pass\b/i
const MONOSPACE_KEY = /key|secret|token|password|senha|url|host|endpoint|appkey|apptoken|id$/i

function hasValue(field: CredentialsField): boolean {
    if (field.type === 'checkbox') {
        return field.value !== undefined && field.value !== null
    }

    return typeof field.value === 'string' ? !!field.value.trim() : field.value !== undefined && field.value !== null && field.value !== ''
}

function getFields(form: CredentialsForm): Array<[string, CredentialsField]> {
    return Object.keys(form || {})
        .filter((key) => !!form[key] && typeof form[key] === 'object')
        .map((key) => [key, form[key]] as [string, CredentialsField])
}

export default {
    isSecretField(key: string): boolean {
        return SECRET_KEY.test(key || '')
    },

    isMonospaceField(key: string): boolean {
        return MONOSPACE_KEY.test(key || '')
    },

    getMissingRequiredFields(form: CredentialsForm): string[] {
        return getFields(form)
            .filter(([, field]) => field.required && !field.readOnly && field.type !== 'checkbox' && !hasValue(field))
            .map(([key]) => key)
    },

    // Há credencial gravada: algum campo de texto preenchido e nenhum obrigatório vazio
    isConfigured(form: CredentialsForm): boolean {
        const textFields = getFields(form).filter(([, field]) => field.type !== 'checkbox')

        if (!textFields.some(([, field]) => hasValue(field))) {
            return false
        }

        return !textFields.some(([, field]) => field.required && !hasValue(field))
    },

    snapshotValues(form: CredentialsForm): string {
        const values: {[key: string]: any} = {}

        for (const [key, field] of getFields(form)) {
            values[key] = typeof field.value === 'string' ? field.value.trim() : (field.value === undefined ? null : field.value)
        }

        return JSON.stringify(values)
    },

    isDirty(form: CredentialsForm, snapshot: string): boolean {
        return this.snapshotValues(form) !== snapshot
    },
}
